module.exports = {
  getStateToZoneMap,
  listStatesAndLGAs,
  getGeoLocationId
}

// Returns: { 'fct': 'north-central' }
function getStateToZoneMap (locations) {
  return locations.reduce((memo, facility) => {
    const { zone, state } = facility.location
    memo[state] = memo[state] || zone
    return memo
  }, {})
}

function listStatesAndLGAs (locations) {
  const lgas = [...new Set(locations.map(facility => facility.location.lga))]
  const states = [...new Set(locations.map(facility => facility.location.state))]
  return {
    lgas,
    states
  }
}

/** Get the geolocation part of the location id.
 * Location ids may contain a `name` field. This function
 * will return the geo location part of the id without the name.
 */
function getGeoLocationId (locationId) {
  const parts = locationId.split(':')
  const nameIndex = parts.indexOf('name')
  let locPart
  if (nameIndex > -1) {
    locPart = parts.slice(0, nameIndex).join(':')
  } else {
    locPart = locationId
  }
  if (locPart === 'national') {
    return 'country:ng'
  } else {
    return 'country:ng:' + locPart
  }
}
